import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {CHANNEL_INFO_BY_CHANNEL, ChannelsHelper} from '../../channels/channels';


const CHANNEL_COLOR_MAP = {
    GOOGLE: '#1AA85D',
    FACEBOOK: '#3B5998',
    TIKTOK: '#000000',
    LINKEDIN: '#0A66C2',
    MERCADO_ADS: '#0A0080',
    ANALYTICS: '#E7B042',
    SHEET: '#cc9250',
    SHOPIFY: '#96BF48',
    TIENDA_NUBE: '#28a7e9',
};

export const AgentContextSelector = ({adAccounts: allAdAccounts, onScopeSelected}) => {
    const {t} = useTranslation();
    const [selectedItemId, setSelectedItemId] = useState(null); // null = todas

    // La familia «Rentabilidad del negocio» (Escalafy) no tiene métricas que consultar: elegirla dejaba al agente
    // con alcance a una cuenta sin datos. La economía la consulta por su propia tool.
    const adAccounts = (allAdAccounts || []).filter((acc) => acc && !ChannelsHelper.channelIsProfitability(acc.channel));
    const hasAccounts = adAccounts.length > 0;

    const handleStart = () => {
        onScopeSelected({adAccountId: selectedItemId});
    };

    return (
        <div className="agent-context-selector">
            <div className="agent-context-selector__icon">
                <i className="fas fa-robot"></i>
            </div>
            <h3 className="agent-context-selector__title">
                {t('agent_chat.context_title')}
            </h3>

            {hasAccounts && (
                <div className="agent-context-selector__section">
                    <div className="agent-context-selector__options">
                        <div
                            className={`agent-context-selector__option ${selectedItemId === null ? 'agent-context-selector__option--selected' : ''}`}
                            onClick={() => setSelectedItemId(null)}
                        >
                            <span className="agent-context-selector__option-text">
                                {t('agent_chat.context_all_accounts')}
                            </span>
                            {selectedItemId === null && (
                                <i className="fas fa-check agent-context-selector__option-check"></i>
                            )}
                        </div>
                        {adAccounts.map(acc => {
                            const channelInfo = CHANNEL_INFO_BY_CHANNEL[acc.channel];
                            const channelName = channelInfo ? channelInfo.Spanish : acc.channel;
                            const dotColor = CHANNEL_COLOR_MAP[acc.channel] || '#999';
                            return (
                                <div
                                    key={acc.id}
                                    className={`agent-context-selector__option ${selectedItemId === acc.id ? 'agent-context-selector__option--selected' : ''}`}
                                    onClick={() => setSelectedItemId(acc.id)}
                                >
                                    <span
                                        className="agent-context-selector__channel-dot"
                                        style={{backgroundColor: dotColor}}
                                    ></span>
                                    <span className="agent-context-selector__option-text">
                                        {channelName} - {acc.name}
                                    </span>
                                    {selectedItemId === acc.id && (
                                        <i className="fas fa-check agent-context-selector__option-check"></i>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            <button
                className="btn -alt agent-context-selector__start-btn"
                onClick={handleStart}
                disabled={!hasAccounts}
            >
                {t('agent_chat.context_start')}
            </button>
        </div>
    );
};
